import React, { useEffect, useRef } from "react";
import "./WelcomePage.css";
import { useNavigate } from "react-router-dom";
import { logAnalyticsEvent } from "../../Databases/analytics_consent";
import Footer from "../Footer/Footer";
import CookieDisclaimer from "./CookieDisclaimer/CookieDisclaimer.jsx";
import WelcomePageHeader from "./WelcomePageHeader/WelcomePageHeader.jsx";
import { useTranslation } from 'react-i18next';

function WelcomePage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const moreRef = useRef(null);

  const handleGuestChat = () => {
    navigate("/guestchat");
  };

  const handleLearnMore = () => {
    moreRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleAboutPage = () => {
    navigate("/about");
  };

  useEffect(() => {
    logAnalyticsEvent("welcome_page_visit");
  }, []);

  return (
    <div className="WelcomePage">
      <WelcomePageHeader />
      <main className="welcome-scroll">
        <section className="hero-section">
          <div className="hero-container">
            <div className="hero-heading">
              <h1 className="mb-4">
                {t('heading')}
              </h1>
              <p>
                Aya is your Dr. Love and modern Matchmaker
              </p>
            </div>
            <div>
              <p><img src="/img/aya-avatar.jpg" alt="Avatar" className="ayaphoto" /></p>
              <p>
              <button className="btn" onClick={handleGuestChat}>Chat with me</button> or <button className="btn" onClick={handleLearnMore}>Learn more</button>
              </p>
            </div>
          </div>
        </section>

        <section className="welcome-more" ref={moreRef}>
          <div className="hero-container">
            <div className="reassurance-badges">
              <span className="reassurance-badge">No wait time</span>
              <span className="reassurance-badge">No cost</span>
              <span className="reassurance-badge">No strings attached</span>
              <span className="reassurance-badge">No login required</span>
            </div>
            <button className="welcome-more-link" onClick={handleAboutPage}>
              See how Aya works →
            </button>
          </div>
        </section>
      </main>
      <Footer />
      <CookieDisclaimer />
    </div>
  );
}
export default WelcomePage;
